<script setup>
/* eslint-disable */
import { reactive, ref, onMounted, watch } from 'vue';
import axios from '@/axios';
import ArgonInput from '@/components/ArgonInput.vue';
import logo from "@/assets/img/fondotam-blanco.png";
import Swal from "sweetalert2";

// --- ESTADO MAESTRO ---
const activoEncontrado = ref(null);
const codigoBusqueda = ref('');
const procesoExitoso = ref(false);

// NUEVO: Variable para controlar el modal flotante
const mostrarModal = ref(false);

const formularioBaja = reactive({
  activo: '',
  num_baja: '',
  regional: '',
  gerencia: '',
  seccion: '', 
  cargo: '',
  solicitante: '', 
  motivosSeleccionados: [],
  motivo: '',
  descripcion_tecnica: '',
  disposicion_final: 'Almacén de Bajas',
  documento: null
});

const opcionesMotivos = [
  { id: 'Obsolescencia', label: 'Obsolescencia Tecnológica' },
  { id: 'Daño', label: 'Daño Irreparable / Siniestro' },
  { id: 'Perdida', label: 'Pérdida o Robo' },
];

const catalogos = reactive({
  regionales: [],
  gerencias: [],
  secciones: [],
  cargos: [],
  usuarios_master: []
});

const listas = reactive({
  regionales: [],
  gerencias: [],
  secciones: [],
  cargos: [],
  usuarios: []
});


onMounted(async () => {
  try {
    const [resReg, resGer, resSec, resCar, resPers] = await Promise.all([
      axios.get('regionales/'),
      axios.get('gerencias/'),
      axios.get('secciones/'),
      axios.get('cargos/'),
      axios.get('designaciones/estructura_completa/')
    ]);

    catalogos.regionales = resReg.data.results || resReg.data;
    catalogos.gerencias = resGer.data.results || resGer.data;
    catalogos.secciones = resSec.data.results || resSec.data;
    catalogos.cargos = resCar.data.results || resCar.data;
    catalogos.usuarios_master = resPers.data;

    listas.regionales = catalogos.regionales;
  } catch (e) {
    console.error("Error de carga inicial", e);
  }
});

// --- LÓGICA DE FILTRADO JERÁRQUICO ---
watch(() => formularioBaja.regional, (newVal) => {
  formularioBaja.gerencia = ''; formularioBaja.seccion = ''; formularioBaja.cargo = ''; formularioBaja.solicitante = '';
  listas.gerencias = []; listas.secciones = []; listas.cargos = []; listas.usuarios = [];

  if (newVal) {
    listas.gerencias = catalogos.gerencias.filter(g => g.regional === newVal || g.regional_id === newVal);
    if (listas.gerencias.length === 0) {
      Swal.fire({ title: 'Atención', text: 'No hay gerencias registradas en esta Regional.', icon: 'warning', toast: true, position: 'top-end', timer: 3000, showConfirmButton: false });
    }
  }
});

watch(() => formularioBaja.gerencia, (newVal) => {
  formularioBaja.seccion = ''; formularioBaja.cargo = ''; formularioBaja.solicitante = '';
  listas.secciones = []; listas.cargos = []; listas.usuarios = [];

  if (newVal) {
    listas.secciones = catalogos.secciones.filter(s => s.gerencia === newVal || s.gerencia_id === newVal);
    if (listas.secciones.length === 0) {
      Swal.fire({ title: 'Gerencia Vacía', text: 'No hay secciones bajo esta Gerencia.', icon: 'info', toast: true, position: 'top-end', timer: 3000, showConfirmButton: false });
    }
  }
});

watch(() => formularioBaja.seccion, (newVal) => {
  formularioBaja.cargo = ''; formularioBaja.solicitante = '';
  listas.cargos = []; listas.usuarios = [];

  if (newVal) {
    listas.cargos = catalogos.cargos.filter(c => c.seccion === newVal || c.seccion_id === newVal);
    if (listas.cargos.length === 0) {
        Swal.fire({ title: 'Sección Vacía', text: 'No hay cargos operativos registrados en esta Sección.', icon: 'info', toast: true, position: 'top-end', timer: 3000, showConfirmButton: false });
    }
  }
});

watch(() => formularioBaja.cargo, (newVal) => {
  formularioBaja.solicitante = '';
  listas.usuarios = [];

  if (newVal) {
    listas.usuarios = catalogos.usuarios_master.filter(p => p.cargo_id === newVal);
    if (listas.usuarios.length === 0) {
      Swal.fire({ title: 'Cargo Vacante', text: 'Nadie ocupa este cargo actualmente.', icon: 'info', toast: true, position: 'top-end', timer: 3000, showConfirmButton: false });
    }
  }
});

// --- BÚSQUEDA DE ACTIVO ---
const buscarActivoExacto = async () => {
  if (!codigoBusqueda.value) return;
  activoEncontrado.value = null;
  try {
    const query = codigoBusqueda.value.trim();
    const { data } = await axios.get(`activos/?search=${query}`);
    if (data && data.length > 0) {
      const activo = data[0];
      if (activo.situacion_activo === 'Baja') {
        Swal.fire("Activo Inhabilitado", "Este bien ya figura como Desincorporado.", "warning");
      } else {
        activoEncontrado.value = activo;
        formularioBaja.activo = activo.id;
        Swal.fire({ icon: 'success', title: 'Activo Localizado', timer: 1000, showConfirmButton: false });
      }
    } else {
      Swal.fire("No encontrado", "Código no registrado.", "error");
    }
  } catch (e) { console.error(e); }
};

const handleFileUpload = (e) => { formularioBaja.documento = e.target.files[0]; };

// --- PROCESAMIENTO ---
const procesarBajaDefinitiva = async () => {
  if (!formularioBaja.num_baja) {
    return Swal.fire("Acta Requerida", "Debe transcribir el número del acta física.", "warning");
  }
  if (formularioBaja.motivosSeleccionados.length === 0) {
    return Swal.fire("Atención", "Seleccione al menos un motivo.", "warning");
  }
  if (!formularioBaja.solicitante) {
    return Swal.fire("Falta Responsable", "Debe seleccionar el funcionario que autoriza la baja.", "warning");
  }
  if (!formularioBaja.documento) {
    return Swal.fire({
      title: "Falta Documento",
      text: "La norma exige adjuntar el Informe Técnico o Denuncia en formato PDF para proceder con la baja patrimonial.",
      icon: "error",
      confirmButtonColor: "#ea0606"
    });
  }
  formularioBaja.motivo = formularioBaja.motivosSeleccionados.join(', ');
  const confirm = await Swal.fire({
    title: '¿Confirmar Baja Definitiva?',
    text: `Se desincorporará el activo ${activoEncontrado.value.codigo_tamep}. Esta acción es irreversible.`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'SÍ, EJECUTAR BAJA',
    confirmButtonColor: '#ea0606',
    cancelButtonText: 'CANCELAR'
  });

  if (!confirm.isConfirmed) return;

  const fd = new FormData();
  fd.append('activo', formularioBaja.activo);
  fd.append('num_baja', formularioBaja.num_baja.toUpperCase());
  fd.append('solicitante', formularioBaja.solicitante);
  fd.append('motivo', formularioBaja.motivo);
  fd.append('descripcion_tecnica', formularioBaja.descripcion_tecnica);
  fd.append('disposicion_final', formularioBaja.disposicion_final);
  if (formularioBaja.documento) fd.append('documento_respaldo', formularioBaja.documento);

  try {
    const response = await axios.post('operacion-baja/', fd);
    procesoExitoso.value = true;
    mostrarModal.value = false; // Cerramos el modal al terminar
    await Swal.fire("Éxito", "Baja patrimonial procesada.", "success");
    imprimirActaBaja(response.data);
    
    // Reseteamos el formulario
    activoEncontrado.value = null;
    codigoBusqueda.value = '';
    Object.assign(formularioBaja, {
      activo: '', num_baja: '', regional: '', gerencia: '', seccion: '', cargo: '', solicitante: '',
      motivosSeleccionados: [], motivo: '', descripcion_tecnica: '', disposicion_final: 'Almacén de Bajas', documento: null
    });
    listas.gerencias = []; listas.secciones = []; listas.cargos = []; listas.usuarios = [];
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) fileInput.value = "";

  } catch (error) {
    console.error(error);
  }
};

const imprimirActaBaja = (dataServer) => {
  const iframe = document.getElementById('impresion-reporte');
  if (!iframe) return;
  const doc = iframe.contentWindow.document;
  const contenido = `
    <html>
      <head>
        <title>Acta de Baja TAMEP</title>
        <style>
          body { font-family: 'Helvetica', sans-serif; padding: 40px; }
          .header { border-bottom: 3px solid #ea0606; padding-bottom: 10px; margin-bottom: 20px; }
          .title { color: #ea0606; font-size: 16pt; font-weight: bold; }
          table { width: 100%; border-collapse: collapse; margin-top: 20px; }
          td { border: 1px solid #aaa; padding: 10px; }
          .label { background: #f2f2f2; font-weight: bold; width: 30%; }
        </style>
      </head>
      <body>
        <div class="header">
          <div class="title">Acta de Baja de Activo Fijo</div>
          <div>No. Acta: ${dataServer.num_baja}</div>
        </div>
        <table>
          <tr><td class="label">Equipo:</td><td>${activoEncontrado.value?.nombre_especifico || ''}</td></tr>
          <tr><td class="label">Código TAMEP:</td><td>${activoEncontrado.value?.codigo_tamep || ''}</td></tr>
          <tr><td class="label">Motivo:</td><td>${formularioBaja.motivo}</td></tr>
          <tr><td class="label">Justificación:</td><td>${formularioBaja.descripcion_tecnica}</td></tr>
        </table>
      </body>
    </html>
  `;
  doc.open(); doc.write(contenido); doc.close();
  setTimeout(() => { iframe.contentWindow.focus(); iframe.contentWindow.print(); }, 500);
};
</script>
<template>
  <div class="container-fluid py-4">

    <div v-if="procesoExitoso" class="card card-custom shadow-lg border-0">
      <div class="card-body p-5 text-center">
        <i class="fas fa-check-circle text-success mb-3" style="font-size: 5rem;"></i>
        <h3 class="text-azul-tamep text-title-custom font-weight-bolder">Baja Procesada</h3>
        <p class="text-custom-muted">El activo ha sido dado de baja en el sistema correctamente.</p>
        <button @click="procesoExitoso = false; codigoBusqueda = ''" class="btn btn-azul-tamep mt-4">NUEVA OPERACIÓN</button>
      </div>
    </div>

    <div v-else class="row">
      
      <div class="col-lg-8">
        <div class="card card-custom shadow-lg border-0 mb-4">
          <div class="header-tamep d-flex flex-column flex-sm-row justify-content-between align-items-center px-4 py-3 border-radius-top gap-3 text-center text-sm-start">
            <div class="d-flex flex-column flex-sm-row align-items-center gap-2 gap-sm-0">
              <div class="logo-container-left me-0 me-sm-3 shadow-sm"><img :src="logo" class="logo-img"></div>
              <div class="border-sm-start ps-sm-3 border-white opacity-8">
                <h6 class="mb-0 text-white text-uppercase font-weight-bolder">Baja Patrimonial</h6>
                <small class="text-white opacity-7">Formulario oficial de Desincorporación Institucional</small>
              </div>
            </div>
          </div>

          <div class="card-body p-3 p-md-5">
            
            <div class="section-title mb-4 d-flex align-items-center">
              <div class="step-number me-2">1</div>
              <h6 class="font-weight-bolder mb-0 text-title-custom">Identificación del Activo</h6>
            </div>
            
            <div class="row g-3 mb-4 mb-md-5">
              <div class="col-12 col-md-9">
                <input v-model="codigoBusqueda" class="form-control form-control-modern input-custom border-2"
                  placeholder="Ingrese Código TAMEP o TAB exacto..." @keyup.enter="buscarActivoExacto">
              </div>
              <div class="col-12 col-md-3">
                <button @click="buscarActivoExacto" class="btn btn-azul-tamep w-100 mb-0 shadow-sm py-2 py-md-2 h-100">
                  <i class="fas fa-search me-2"></i> BUSCAR
                </button>
              </div>
            </div>

            <div v-if="activoEncontrado">
              
              <div class="row mb-4 bg-section-custom p-3 border-radius-lg border-custom-divider mx-0" style="border: 1px solid #e9ecef;">
                <div class="col-12 col-md-6 mb-3 mb-md-0 text-center text-md-start">
                  <label class="label-custom">Equipo Registrado</label>
                  <p class="fw-bold mb-0 text-custom fs-6">{{ activoEncontrado.nombre_especifico }}</p>
                  <p class="text-xs text-custom-muted mb-0">COD: {{ activoEncontrado.codigo_tamep }}</p>
                </div>
                <div class="col-12 col-md-6 text-center text-md-end">
                  <label class="label-custom">Situación Actual</label>
                  <p :class="['mb-0 fw-bold fs-6', activoEncontrado.situacion_activo === 'Baja' ? 'text-danger' : 'text-success']">
                    {{ activoEncontrado.situacion_activo }}
                  </p>
                </div>
              </div>

              <div class="section-title mb-4 d-flex align-items-center border-top pt-4 border-custom-divider">
                <div class="step-number me-2">2</div>
                <h6 class="font-weight-bolder mb-0 text-title-custom">Datos de Autorización</h6>
              </div>

              <div class="row g-3">
                <div class="col-12">
                  <label class="label-custom text-navy-slate fw-800">Nro. de Acta de Baja (Física)</label>
                  <input v-model="formularioBaja.num_baja" class="form-control input-custom font-weight-bold"
                    placeholder="Ej: BAJA-2026-001" style="text-transform: uppercase;">
                </div>

                <div class="col-12 col-md-6">
                  <label class="label-custom">Regional Administrativa</label>
                  <select v-model="formularioBaja.regional" class="form-select-custom select-custom">
                    <option value="">Seleccione...</option>
                    <option v-for="r in listas.regionales" :key="r.id" :value="r.id">{{ r.nombre }}</option>
                  </select>
                </div>

                <div class="col-12 col-md-6">
                  <label class="label-custom">Gerencia</label>
                  <select v-model="formularioBaja.gerencia" :disabled="!formularioBaja.regional" class="form-select-custom select-custom">
                    <option value="">Seleccione...</option>
                    <option v-for="g in listas.gerencias" :key="g.id" :value="g.id">{{ g.nombre }}</option>
                  </select>
                </div>

                <div class="col-12 col-md-6">
                  <label class="label-custom text-info fw-800">Sección / Área</label>
                  <select v-model="formularioBaja.seccion" :disabled="!formularioBaja.gerencia" class="form-select-custom select-custom border-info-light">
                    <option value="">Seleccione...</option>
                    <option v-for="s in listas.secciones" :key="s.id" :value="s.id">{{ s.nombre }}</option>
                  </select>
                </div>

                <div class="col-12 col-md-6">
                  <label class="label-custom">Cargo</label>
                  <select v-model="formularioBaja.cargo" :disabled="!formularioBaja.seccion" class="form-select-custom select-custom">
                    <option value="">Seleccione...</option>
                    <option v-for="c in listas.cargos" :key="c.id" :value="c.id">{{ c.nombre }}</option>
                  </select>
                </div>

                <div class="col-12">
                  <label class="label-custom text-navy-slate fw-800">Funcionario Autorizador (Solicitante)</label>
                  <select v-model="formularioBaja.solicitante" :disabled="!formularioBaja.cargo" class="form-select-custom select-custom border-primary-light fw-bold text-custom">
                    <option value="">Seleccione al funcionario...</option>
                    <option v-for="u in listas.usuarios" :key="u.id" :value="u.id">{{ u.nombre_completo }}</option>
                  </select>
                </div>

                <div class="col-12 border-top mt-4 mt-md-5 pt-4 border-custom-divider">
                  <div class="section-title mb-3 mb-md-4 d-flex align-items-center">
                    <div class="step-number me-2">3</div>
                    <h6 class="font-weight-bolder mb-0 text-title-custom">Detalles Técnicos y Respaldo</h6>
                  </div>
                </div>

                <div class="col-12 my-2">
                  <label class="label-custom text-dark">Motivos de Desincorporación (Seleccione uno o más)</label>
                  <div class="d-flex flex-column flex-sm-row flex-wrap gap-2 gap-sm-3 p-3 bg-section-custom border-radius-modern border border-custom-divider">
                    <div v-for="opt in opcionesMotivos" :key="opt.id" class="form-check mb-0">
                      <input class="form-check-input" type="checkbox" :id="opt.id" :value="opt.id"
                        v-model="formularioBaja.motivosSeleccionados">
                      <label class="form-check-label text-xs fw-bold text-custom-muted mb-0" :for="opt.id">
                        {{ opt.label }}
                      </label>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <label class="label-custom">Disposición Final del Bien</label>
                  <select v-model="formularioBaja.disposicion_final" class="form-select-custom select-custom">
                    <option value="Almacén de Bajas">Enviar a Almacén de Bajas</option>
                    <option value="Chatarrización">Baja Definitiva / Destrucción</option>
                  </select>
                </div>
                
                <div class="col-12">
                  <label class="label-custom mt-2">Justificación Técnica del Estado (Resumen)</label>
                  <textarea v-model="formularioBaja.descripcion_tecnica" class="form-control input-custom border-custom-divider" rows="3"></textarea>
                </div>
                
                <div class="col-12">
                  <label class="label-custom text-danger fw-800 text-wrap">Informe PDF o Acta Firmada de Respaldo</label>
                  <input type="file" class="form-control input-custom border-custom-divider p-2" @change="handleFileUpload" accept=".pdf">
                </div>
              </div>

              <button @click="procesarBajaDefinitiva" class="btn btn-danger w-100 mt-4 mt-md-5 shadow-sm py-3 text-wrap" :disabled="activoEncontrado.situacion_activo === 'Baja'" style="background-color: #DC2626; font-weight: 700;">
                <i class="fas fa-trash-alt me-2"></i> FINALIZAR BAJA TÉCNICA
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 mt-4 mt-lg-0">
        <div class="card h-100 card-sidebar-log border-0 shadow-lg p-3 p-md-4">
          <div class="header-sidebar mb-3 border-bottom pb-3 border-custom-divider text-center text-lg-start">
              <h6 class="text-navy-slate text-uppercase font-weight-bolder mb-0">Módulo de Auditoría</h6>
              <p class="text-custom-muted text-xs mb-0">Garantía y Legalidad en Bajas</p>
          </div>
          
          <div class="log-item d-flex mb-4 align-items-center">
            <div class="icon-wrap me-2 me-md-3 text-success flex-shrink-0"><i class="fas fa-file-invoice fa-lg"></i></div>
            <div class="text-custom text-xs">Validación de Activos Fijos vinculada a la base de datos central de TAMEP.</div>
          </div>
          
          <div class="log-item d-flex mb-4 align-items-center">
            <div class="icon-wrap me-2 me-md-3 text-info flex-shrink-0"><i class="fas fa-user-shield fa-lg"></i></div>
            <div class="text-custom text-xs">Cierre automático de la custodia legal del funcionario asignado.</div>
          </div>
          
          <div class="log-item d-flex align-items-center">
            <div class="icon-wrap me-2 me-md-3 text-warning flex-shrink-0"><i class="fas fa-balance-scale fa-lg"></i></div>
            <div class="text-custom text-xs">Cumplimiento estricto de las normas básicas de administración de bienes.</div>
          </div>
          
          <div class="asset-preview-section mt-4 mt-md-5 border-top pt-4 border-custom-divider" v-if="activoEncontrado">
              <label class="label-custom">Vista Previa del Activo</label>
              <div class="card card-body border border-custom-divider shadow-none bg-section-custom p-3 flex-row align-items-center">
                  <img v-if="activoEncontrado.imagen_activo" :src="activoEncontrado.imagen_activo" style="width: 50px; height: 50px; object-fit: cover; border-radius: 8px;" class="me-3 border flex-shrink-0">
                  <div v-else class="bg-white border rounded d-flex align-items-center justify-content-center me-3 flex-shrink-0" style="width: 50px; height: 50px;">
                    <i class="fas fa-image text-custom-muted"></i>
                  </div>
                  <div>
                      <h6 class="text-xs text-navy-slate mb-1 text-wrap">{{ activoEncontrado.nombre_especifico }}</h6>
                      <p class="text-custom-muted text-xxs mb-0 text-wrap">Código: {{ activoEncontrado.codigo_tamep }}</p>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>

    <iframe id="impresion-reporte" style="display:none;"></iframe>
  </div>
</template>

<style scoped>
/* 3. Se removieron los transition: all para evitar desplazamientos y saltos de layout */
.card-custom { background-color: #ffffff; transition: background-color 0.3s ease, box-shadow 0.3s ease; border-radius: 8px; }
.input-custom { border-radius: 6px; transition: border-color 0.3s ease, box-shadow 0.3s ease; }

.text-title-custom { color: #344767; }
.text-custom-muted { color: #6c757d; }
.border-custom-divider { border-color: #e9ecef !important; transition: border-color 0.3s ease; }
.bg-section-custom { background-color: #f8f9fa; border-radius: 8px; transition: background-color 0.3s ease; }
.select-custom { background-color: #ffffff; color: #495057; border-color: #e9ecef; transition: border-color 0.3s ease, box-shadow 0.3s ease; }

/* Estilos TAMEP Generales */
.header-tamep { background: linear-gradient(135deg, #003366 0%, #001d3d 100%); }
.border-radius-top { border-top-left-radius: 8px; border-top-right-radius: 8px; }
.border-radius-modern { border-radius: 8px; }
.logo-container-left { background: white; padding: 5px 12px; border-radius: 8px; }
.logo-img { max-height: 35px; }
.text-azul-tamep { color: #003366; }
.btn-azul-tamep { background-color: #003366; color: white; border: none; font-weight: 700; border-radius: 8px; padding: 10px 15px; transition: background-color 0.3s ease, transform 0.3s ease;}
.btn-azul-tamep:hover:not(:disabled) { background-color: #001d3d; }
.btn-azul-tamep:disabled { opacity: 0.6; cursor: not-allowed; }
.label-custom { font-size: 0.65rem; font-weight: 800; text-transform: uppercase; color: #8392ab; margin-bottom: 4px; display: block; }

.form-select-custom { display: block; width: 100%; padding: 0.5rem; font-size: 0.85rem; border: 1px solid #d2d6da; border-radius: 0.5rem; }
.form-select-custom:focus { border-color: #003366; outline: none; box-shadow: 0 0 0 2px rgba(0,51,102,0.1); }
.step-number { background: #003366; color: white; width: 24px; height: 24px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 0.75rem; font-weight: bold; }
.border-info-light { border-color: #17a2b880 !important; }
.border-primary-light { border-color: #00336680 !important; }

.icon-wrap { width: 40px; text-align: center; }

/* SOPORTE PARA MODO OSCURO (DARK MODE) */
:global(.dark-mode) .card-custom { background-color: #1e1e1e !important; box-shadow: 0 4px 15px rgba(0,0,0,0.5) !important; border: 1px solid #2d2d2d !important; }
:global(.dark-mode) .text-custom { color: #e0e0e0 !important; }
:global(.dark-mode) .text-title-custom { color: #ffffff !important; }
:global(.dark-mode) .text-custom-muted { color: #aaaaaa !important; }
:global(.dark-mode) .border-custom-divider { border-color: #333333 !important; }
:global(.dark-mode) .bg-section-custom { background-color: #2c2c2c !important; border: 1px solid #333 !important; }

:global(.dark-mode) .input-custom,
:global(.dark-mode) .select-custom { 
  background-color: #2a2a2a !important; 
  color: #e0e0e0 !important; 
  border-color: #444444 !important; 
}
:global(.dark-mode) .input-custom:focus,
:global(.dark-mode) .select-custom:focus { 
  border-color: #4dabf7 !important; 
}
:global(.dark-mode) .input-custom::placeholder { color: #888 !important; }

:global(.dark-mode) .select-custom:disabled,
:global(.dark-mode) .input-custom:disabled {
  background-color: #1a1a1a !important;
  color: #666 !important;
  border-color: #333 !important;
  opacity: 1;
}
:global(.dark-mode) .text-azul-tamep.text-title-custom { color: #4dabf7 !important; }
</style>